var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 2C9.19386 2 6.00646 4.65879 5.19808 8.22129C5.07587 8.75988 4.54018 9.09742 4.00159 8.97521C3.463 8.85299 3.12545 8.31731 3.24767 7.77871C4.25821 3.32525 8.23951 0 12.9999 0C16.8366 0 20.1672 2.16004 21.8443 5.32986L22.6623 2.27708C22.8052 1.74362 23.3536 1.42703 23.887 1.56998C24.4205 1.71292 24.7371 2.26125 24.5941 2.79472L23.13 8.25882C22.9871 8.79229 22.4388 9.10887 21.9053 8.96593L16.4412 7.50183C15.9077 7.35889 15.5911 6.81055 15.7341 6.27708C15.877 5.74362 16.4254 5.42703 16.9588 5.56998L20.1603 6.42781C18.848 3.8025 16.1336 2 12.9999 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C10 17.7116 9.87552 17.4373 9.65851 17.2474L1.65851 10.2474C1.36321 9.98903 0.944095 9.92721 0.586784 10.0894C0.229473 10.2515 0 10.6076 0 11V25C0 25.3924 0.229472 25.7485 0.586783 25.9106C0.944095 26.0728 1.36321 26.0109 1.6585 25.7526L9.65851 18.7526C9.87552 18.5627 10 18.2883 10 18ZM2 22.7962L2 13.2038L7.48141 18L2 22.7962Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18C16 17.7116 16.1245 17.4373 16.3415 17.2474L24.3415 10.2474C24.6368 9.98903 25.0559 9.92721 25.4132 10.0894C25.7705 10.2515 26 10.6076 26 11V25C26 25.3924 25.7705 25.7485 25.4132 25.9106C25.0559 26.0728 24.6368 26.0109 24.3415 25.7526L16.3415 18.7526C16.1245 18.5627 16 18.2883 16 18ZM24 13.2038L18.5186 18L24 22.7962V13.2038Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11C14 10.4477 13.5523 10 13 10C12.4477 10 12 10.4477 12 11L12 25C12 25.5523 12.4477 26 13 26C13.5523 26 14 25.5523 14 25L14 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorIcon);
export default __webpack_public_path__ + "static/media/mirror-icon.2810e2666504ec1e39a717d19a156822.svg";
export { ForwardRef as ReactComponent };